<template>
  <div class="flex justify-between items-center gap-2 py-2 px-3 rounded-lg border-1 border-border-light">
    <div class="normal-emphasis font-semibold truncate">
      <span>{{ description }}</span>
      <span v-if="optionDescription" class="text-sm">
        ({{ optionDescription }})
      </span>
    </div>
    <div class="text-right font-medium">
      {{ formatCurrency(amount) }}
    </div>
  </div>
</template>
<script setup lang="ts">
import useLocalization from '@/modules/useLocalization';
const { formatCurrency } = useLocalization();

interface Props {
  description: string;
  amount: number;
  optionDescription?: string | null | undefined;
}

const props = defineProps<Props>();
</script>
